// import { CHANGE_LANGUAGE } from "../constants/languageConstant";

export const eLearningReducer = (state= {}, action) => {
    switch (action.type) {
        case "ELEARNING_PROGRESS":
            return {answers: action.payload}
        default:
            return state;
    }
}